import { Account } from 'models/Account';
import { User } from 'models/User';
import { RootState } from 'store';

export const selectUser = (state: RootState) => state.auth.user as User & Account;

export const selectLoggedIn = (state: RootState) => !!state.auth.user;

export const selectAuthStatus = (state: RootState) => state.auth.status;
